
import { QueryClient, QueryKey } from "@tanstack/react-query";

// Create a more performant query client with optimized defaults
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes (increased from 5 minutes)
      gcTime: 10 * 60 * 1000, // 10 minutes (cache for longer than stale time)
      retry: 1, // Only retry failed queries once
      refetchOnWindowFocus: false, // Don't refetch when window regains focus (reduces network calls)
      refetchOnMount: true, // But do refetch when component mounts
      refetchOnReconnect: true, // Refetch on network reconnection
    },
  },
});

// Add these helper methods for improved cache management
export const prefetchData = async <T>(queryKey: QueryKey, queryFn: () => Promise<T>) => {
  return queryClient.prefetchQuery({
    queryKey,
    queryFn,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
};

export const invalidateQueries = (queryKey: QueryKey) => {
  return queryClient.invalidateQueries({ queryKey });
};

export const setQueryData = <T>(queryKey: QueryKey, data: T) => {
  return queryClient.setQueryData<T>(queryKey, data);
};
